import React from "react";
import {QuoteWorkbench} from "./workspace/QuoteWorkbench";

export const QuotePrepSection = props => <QuoteWorkbench {...props}/>;